import { formatGanttTaskToTask } from '@blackhyve/utilities/gantt';
import ganttStore from 'components/projectOverview/gantt/ganttConfig/ganttStore';
import store from '../../../../store';
import {
  addDependency,
  bulkDeleteDependency,
  updateDependencies,
} from '../../../dependencies/store/dependenciesSlice';
import { createTask, deleteTasks, updateTasks } from '../../../tasks/store/tasksSlice';
import { hasChild } from '@blackhyve/utilities/tasks';

let dataProcessor = undefined;
let autoUpdateTimer = 0;
const pendingUpdates = { updateTasks: {}, deleteTasks: [], updateLinks: {}, deleteLinks: [] };

export const taskGanttDataProcessor = (ganttId) => {
  const gantt = ganttStore.getGantt(ganttId);

  gantt.attachEvent('onAfterTaskMove', function (id, parent, tindex) {
    const task = gantt.getTask(id);
    if (task.isSocketUpdate) {
      delete task.isSocketUpdate;
      return true;
    }

    if (gantt.getNextSibling(id) !== null) {
      task.target = gantt.getNextSibling(id);
    } else if (gantt.getPrevSibling(id) !== null) {
      task.target = 'next:' + gantt.getPrevSibling(id);
    } else {
      task.target = 'next:null';
    }
    updateTask(task);
    autoUpdate();
    delete task.target;
  });

  gantt.attachEvent('onAfterTaskAdd', function (id, task) {
    if (task.type !== 'placeholder') {
      if (task.parent === 0 && gantt.config.project_bar) {
        task.parent = -1;
      }
      store
        .dispatch(createTask(formatGanttTaskToTask(task)))
        .unwrap()
        .then((apiResponse) => {
          gantt.changeTaskId(task.id, apiResponse.id);
        });
    }
  });
  gantt.attachEvent('onAfterTaskUpdate', function (id, task) {
    if (task.type !== 'placeholder' && task.type !== 'project_bar' && !task.$virtual) {
      updateTask(task);
      autoUpdate();
    }
  });
  gantt.attachEvent('onAfterTaskDelete', function (id) {
    // Need to delete children and links
    if (hasChild(id, gantt)) {
      gantt.eachTask(function (task) {
        deleteTask(task.id);
      }, id);
    }
    deleteTask(id);
    autoUpdate();
  });
  gantt.attachEvent('onAfterLinkAdd', function (id, link) {
    // If already created link in database throw SelectDependencyPopup so no need to create again in DB
    if (link.isCreated) {
      return true;
    }
    store
      .dispatch(
        addDependency({
          source: link.source,
          target: link.target,
          type: link.type,
          lag: link.lag,
        })
      )
      .unwrap()
      .then((apiResponse) => {
        if (gantt.isLinkExists(id)) {
          gantt.changeLinkId(id, apiResponse.data.id);
          gantt.refreshLink(apiResponse.data.id);
        }
      });
  });
  gantt.attachEvent('onAfterLinkUpdate', function (id, link) {
    if (link.isUpdated) {
      return true;
    }

    updateLink(link);
    autoUpdate();
  });
  gantt.attachEvent('onAfterLinkDelete', function (id) {
    deleteLink(id);
    autoUpdate();
  });

  // gantt.createDataProcessor({
  //   task: {
  //     create: (data) => {
  //       // return createRecord({ type: 'task', ...data }).then((res) => {
  //       //   return { tid: res.id, ...res };
  //       // });
  //       return { tid: 123 };
  //     },
  //     update: (data, id) => {
  //       // return updateRecord({ type: 'task', ...data }).then(() => ({}));
  //       return {};
  //     },
  //     delete: (id) => {
  //       // return deleteRecord({ type: 'task:', id: id }).then(() => ({}));
  //       return {};
  //     },
  //   },
  //   link: {
  //     create: (data) => ({}),
  //     update: (data, id) => ({}),
  //     delete: (id) => ({}),
  //   },
  // });
  // gantt.createDataProcessor({
  //   task: {
  //     create: function (data) {},
  //     update: function (data, id) {},
  //     delete: function (id) {},
  //   },
  //   link: {
  //     create: function (data) {},
  //     update: function (data, id) {},
  //     delete: function (id) {},
  //   },
  // });

  // dataProcessor = gantt.createDataProcessor({
  //   task: {
  //     create: async (data) => {
  //       if (!data.isCreated) {
  //         return store.dispatch(createTask(formatGanttTaskToTask(data))).then((apiResponse) => {
  //           autoUpdate();
  //           return apiResponse.payload;
  //         });
  //       }
  //     },
  //     update: (data, id) => {
  //       updateTask(data);
  //       autoUpdate();
  //     },
  //     delete: (id) => {
  //       deleteTask(id);
  //       autoUpdate();
  //     },
  //   },
  //   link: {
  //     create: async (data) => {
  //       if (!data.isCreated) {
  //         return store
  //           .dispatch(
  //             addDependency({
  //               source: data.source,
  //               target: data.target,
  //               type: data.type,
  //               lag: data.lag,
  //             })
  //           )
  //           .then((apiResponse) => {
  //             autoUpdate();
  //             return apiResponse.payload.data;
  //           });
  //       }
  //     },
  //     update: (data, id) => {
  //       updateLink(data);
  //       autoUpdate();
  //     },
  //     delete: (id) => {
  //       deleteLink(id);
  //       autoUpdate();
  //     },
  //   },
  // });

  // dataProcessor.attachEvent('onBeforeUpdate', function (id, state, data) {
  //   //Need to check if placeholder
  //   if (Object.keys(data).length <= 2 || data.type === gantt.config.types.placeholder) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // });

  // dataProcessor.attachEvent('onAfterUpdate', function (tempId, action, tid, response) {
  //   switch (action) {
  //     case 'inserted': {
  //       if (response && response.object_type == 'task' && tempId !== response.id) {
  //         gantt.changeTaskId(tempId, response.id);
  //         gantt.showTask(response.id);
  //       }
  //       if (response && response.object_type == 'dependency' && tempId !== response.id) {
  //         if (gantt.isLinkExists(tempId)) {
  //           gantt.changeLinkId(tempId, response.id);
  //         }
  //       }
  //       break;
  //     }
  //     case 'error':
  //       break;
  //     default:
  //       break;
  //   }
  // });
};

export const updateTask = (task) => {
  pendingUpdates.updateTasks[task.id] = formatGanttTaskToTask(task);
};

export const deleteTask = (id) => {
  pendingUpdates.deleteTasks.push(id);
};

export const updateLink = (link) => {
  pendingUpdates.updateLinks[link.id] = link;
};

export const deleteLink = (id) => {
  pendingUpdates.deleteLinks.push(id);
};

const autoUpdate = () => {
  clearTimeout(autoUpdateTimer);
  autoUpdateTimer = setTimeout(async () => {
    processPendingUpdates();
  }, 500);
};

export const removeDataProcessorDefault = () => {
  if (dataProcessor) {
    dataProcessor.destructor();
    dataProcessor = null;
    clearTimeout(autoUpdateTimer);
    processPendingUpdates();
  }
};

const processPendingUpdates = async () => {
  if (pendingUpdates.updateTasks && Object.values(pendingUpdates.updateTasks)?.length) {
    store.dispatch(updateTasks(Object.values(pendingUpdates.updateTasks))).then(() => {
      pendingUpdates.updateTasks = {};
    });
  }

  if (pendingUpdates.deleteTasks && pendingUpdates.deleteTasks.length) {
    store.dispatch(deleteTasks({ tasks: pendingUpdates.deleteTasks })).then(() => {
      pendingUpdates.deleteTasks = [];
    });
  }

  if (pendingUpdates.updateLinks && Object.values(pendingUpdates.updateLinks)?.length) {
    store.dispatch(updateDependencies(Object.values(pendingUpdates.updateLinks))).then(() => {
      pendingUpdates.updateLinks = {};
    });
  }

  if (pendingUpdates.deleteLinks && pendingUpdates.deleteLinks.length) {
    store.dispatch(bulkDeleteDependency({ ids: pendingUpdates.deleteLinks })).then(() => {
      pendingUpdates.deleteLinks = [];
    });
  }
};
